import { HStack, Skeleton, VStack } from '@frontend/legacy-components';

type TabsSkeletonProps = {
  tabIds: string[] | readonly string[];
};

export const TabsSkeleton = ({ tabIds }: TabsSkeletonProps) => {
  return (
    <VStack minHeight={0} flexBasis="100%" alignItems="stretch" spacing={2}>
      <HStack
        width="100%"
        flexGrow={0}
        flexShrink={0}
        justifyContent="space-between"
      >
        <HStack flexGrow={1} flexShrink={1} flexBasis="100%" overflowX="hidden">
          {tabIds.map((tabId) => (
            <Skeleton key={tabId} height={5} width={15} flexShrink={0} />
          ))}
        </HStack>
        <Skeleton height={5} width={5} flexGrow={0} flexShrink={0} />
      </HStack>
      <VStack
        alignItems="stretch"
        flexGrow={1}
        flexShrink={1}
        flexBasis="100%"
        spacing={0.5}
        overflowY="hidden"
      >
        <Skeleton height={4} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
        <Skeleton height={7} flexShrink={0} />
      </VStack>
      <Skeleton height={5} flexGrow={0} flexShrink={0} />
    </VStack>
  );
};
